
import { Link } from "react-router-dom";
import { Home, Search, Info, DollarSign } from "lucide-react";
import { useTranslation } from "react-i18next";

interface MobileMenuMainItemsProps {
  onLinkClick: () => void;
}

const MobileMenuMainItems = ({ onLinkClick }: MobileMenuMainItemsProps) => {
  const { t } = useTranslation();
  
  const mainMenuItems = [
    { label: t("nav.home"), icon: Home, path: "/" },
    { label: t("nav.explore"), icon: Search, path: "/explore" },
    { label: t("nav.about"), icon: Info, path: "/about" },
    { label: t("nav.pricing"), icon: DollarSign, path: "/pricing" }
  ];

  return (
    <>
      {mainMenuItems.map(item => (
        <Link
          key={item.path}
          to={item.path}
          onClick={onLinkClick}
          className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist"
        >
          <item.icon className="h-4 w-4" />
          {item.label}
        </Link>
      ))}
    </>
  );
};

export default MobileMenuMainItems;
